import * as Actions from '../../actions/fuse/index';

import config from '../../../../app/locale/fr/navigation';

const initialState = config;

const navigation = function (state = initialState, action)
{
    switch ( action.type )
    {
        case Actions.GET_NAVIGATION:
        {
            return [
                ...state
            ];
        }
        case Actions.SET_NAVIGATION:
        {
            return [
                ...action.navigation
            ];
        }
        case Actions.RESET_NAVIGATION:
        {
            return [
                ...initialState
            ];
        }
        default:
        {
            return state;
        }
    }
};

export default navigation;


// WEBPACK FOOTER //
// ./src/@fuse/store/reducers/fuse/navigation.reducer.js